import React from 'react';

import BioentityTableSelector from './BioentityTableSelector';
import ExcludeDuplicatesCheckbox from './ExcludeDuplicatesCheckbox';
import SQLColumnSelectorTable from './SQLColumnSelectorTable';
import SQLFilterSelector from './SQLFilterSelector';
import {isFormStateInitialized, SQLTemplateFormComponentProps} from './SQLTemplateFormTypes';
import {SQLTemplateFormStepWrapper} from './SQLTemplateFormWrapper';

export default function BioentitySQLTemplateForm(props: SQLTemplateFormComponentProps): JSX.Element {
  const {availableColumns, columnFilters, selectedTable} = isFormStateInitialized(props.sqlTemplateFormState)
    ? props.sqlTemplateFormState
    : {
        availableColumns: [],
        columnFilters: [],
        selectedTable: null,
      };

  return (
    <>
      <SQLTemplateFormStepWrapper title="1. Select data">
        <BioentityTableSelector
          selectedTable={props.sqlTemplateFormState.selectedTable}
          setSelectedTable={props.setSelectedTable}
        />
        <ExcludeDuplicatesCheckbox
          excludeDuplicates={props.sqlTemplateFormState.excludeDuplicates}
          setExcludeDuplicates={props.setExcludeDuplicates}
        />
      </SQLTemplateFormStepWrapper>
      <SQLTemplateFormStepWrapper title="2. Choose fields to include">
        <SQLColumnSelectorTable
          availableColumns={availableColumns}
          updateColumnState={props.updateColumnState}
          updateColumnStatesInRange={props.updateColumnStatesInRange}
          updateAllColumnStates={props.updateAllColumnStates}
        />
      </SQLTemplateFormStepWrapper>
      <SQLTemplateFormStepWrapper title="3. Filter results">
        <SQLFilterSelector
          availableColumns={availableColumns}
          columnFilters={columnFilters}
          disabled={!isFormStateInitialized(props.sqlTemplateFormState)}
          selectedTable={selectedTable}
          updateColumnFilters={props.updateColumnFilters}
        />
      </SQLTemplateFormStepWrapper>
    </>
  );
}
